<div class="full-height layout-column conversation-container">

  <div class="conversation-header layout-row layout-align-start-center gap-10 padding-10">
    <button *ngIf="!!enableBack" type="button" class="btn btn-outline-primary border-none back-button" (click)="onBack.emit(conversation)">&#x2039;</button>

      <chat-user-avatar [isSmall]="true"
                        [url]="(conversation.attributes?.['serviceId']) ? 'assets/images/avatars/service-avatar.png' : (conversationUsers?.length && conversationUsers.length > 1) ? 'assets/images/avatars/group-avatar.png' : (conversationUsers?.length && conversationUsers.length === 1) ? conversationUsers[0].attributes['avatarUrl'] : ''"
                        [name]="conversation.attributes?.['serviceId'] ? 'S' : (conversationUsers.length ? conversationUsers[0].attributes['fullName'] : '')"
                        [color]="color">

      </chat-user-avatar>

    <div class="flex layout-row gap-5">

<!--      <span *ngIf="conversation.attributes?.serviceId && !usersTyping.length" class="br-body-2 name">{{conversation.attributes?.serviceExternalId || conversation.attributes?.serviceId}}</span>-->
      <div *ngIf="conversationUsers.length && !usersTyping.length" class="flex layout-column gap-5">
        <span *ngIf="conversation.attributes?.['supportId']" class="br-body-2 name">Support-{{conversation.attributes['supportId']}}</span>
        <app-service-link *ngIf="conversation.attributes?.['serviceId']"
                          [serviceType]="conversation.attributes['serviceType']"
                          [id]="conversation.attributes['serviceId']"
                          [externalId]="conversation.attributes['serviceExternalId']">

        </app-service-link>

        <span class="br-body-2 text-ellipsis name">{{conversationUsers | chatConversationNamePipe}}</span>
      </div>
      <span *ngIf="usersTyping.length" class="br-body-2 name">{{usersTyping | chatConversationNamePipe}} Typing</span>
    </div>

    <button *ngIf="!editingConversationUsers" type="button" class="btn btn-outline-primary border-none editing-user-button padding-5" (click)="onEnableEditingUsers()">
      <i class="bi bi-pencil"></i>
    </button>
    <button *ngIf="!!enableClose" type="button" class="btn btn-outline-primary border-none" (click)="onClose.emit()">&#10006;</button>
  </div>

  <div *ngIf="!!editingConversationUsers" class="conversation-header layout-column padding-5">
    <div class="flex layout-row layout-align-start-center">
      <chat-user-input class="flex"
                       (onSelect)="onAddEditingUser($event)">

      </chat-user-input>
      <button type="button" class="btn btn-primary transparent-background border-none" (click)="onSaveEditingUsers()">
        <i class="bi bi-floppy"></i>
      </button>
      <button type="button" class="btn btn-primary transparent-background border-none close-button" (click)="onDisableEditingUsers()">&#10006;</button>
    </div>
    <div class="flex layout-row layout-align-start-center gap-10 layout-wrap padding-10">
      <div *ngFor="let user of editingConversationUsers"
           class="badge badge-pill badge-primary layout-row layout-align-start-center">
        <span class="br-body-2">{{user.attributes?.['fullName'] || (user.firstName + ' ' + user.lastName)}}</span>
        <button type="button" class="btn btn-primary border-none padding-bottom-5 transparent-background" (click)="onRemoveEditingUser(user)">
          <i class="bi bi-x"></i>
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="messagesPaginator?.items.length" class="flex layout-column overflow-auto column-reverse gap-10 padding-10">
    <chat-conversation-message *ngFor="let message of messagesPaginator.items"
                               [message]="message">

    </chat-conversation-message>
  </div>
  <div *ngIf="!messagesPaginator?.items.length"
       class="flex layout-column layout-align-center-center fade-element-in-only">
    <img class="empty-state" src="assets/images/empty_state/empty_state_user.png"/>
  </div>
  <div class="layout-row layout-align-start-center padding-5">
    <div class="input-group flex-nowrap">
      <input type="text" class="form-control" id="searchBox"
             aria-label="message-input"
             [(ngModel)]="text"
             (keyup.enter)="sendMessage()"
             (keydown)="onTyping($event)">

<!--      <textarea type="text" class="form-control" id="searchBox"-->
<!--                aria-label="message-input"-->
<!--                [(ngModel)]="text"-->
<!--                (keyup.enter)="sendMessage()"-->
<!--                (keydown)="onTyping($event)"-->
<!--                oninput='this.style.height = "";this.style.height = this.scrollHeight + "px"'></textarea>-->

      <button id="send-message-btn" class="btn btn-outline-primary" (click)="sendMessage()">
        <i class="bi bi-send-fill"></i>
      </button>

    </div>

    <input hidden type="file" #uploader accept="image/png, image/gif, image/jpeg" (change)="onUploadMedia($event)"/>
    <button id="file-button" class="btn btn-lg" [ngClass]="media ? 'btn-secondary' : 'btn-outline-primary'"
            (click)="uploader.click()">
      <i class="bi bi-card-image"></i>
    </button>
  </div>
</div>
